import { PatientTabProps } from '~/lib/constants/patients.constants';

import AssessmentsRedesignPage from '../assessments-redesign/AssessmentsRedesignPage';

export const PatientAssessmentsRedesignTab = (
  patientTabProps: PatientTabProps,
) => (
  <AssessmentsRedesignPage
    patient={patientTabProps.patient}
    patientId={patientTabProps.patientId}
    patientPreferredFullName={patientTabProps.patientPreferredFullName}
    updateAssessmentState={patientTabProps.updateAssessmentState}
  />
);
